import { FirebaseError } from "firebase/app";

/**
 * Maps a Firebase Functions error (or any thrown value) to a user-friendly message.
 *
 * For `failed-precondition` we surface the server's own message verbatim so
 * specific reasons ("This invite has expired", "Promote another admin before
 * leaving.", "You cannot leave your personal organization.") reach the user.
 */
export function mapFirebaseError(err: unknown): string {
  if (err instanceof FirebaseError) {
    // Functions errors have codes like "functions/not-found" or just "not-found".
    const code = err.code.replace(/^functions\//, "");
    switch (code) {
      case "not-found":
        return "Invite code not found.";
      case "already-exists":
        return "You're already a member of this organization.";
      case "permission-denied":
        return "You don't have permission to do that.";
      case "unauthenticated":
        return "Please sign in to continue.";
      case "failed-precondition":
        return err.message || "This action can't be completed right now.";
      case "invalid-argument":
        return err.message || "Invalid input.";
      default:
        return err.message || "Something went wrong. Please try again.";
    }
  }
  if (err instanceof Error) return err.message;
  return "Something went wrong. Please try again.";
}
